import clienteAxios from "../config/axios";

export async function getAllActivoTypes() {
    return clienteAxios.get(`/activoType`);
}

export async function addactivoType(activoType) {

    return clienteAxios.post(`/activoType`,activoType);
    
}

export async function updateActivoType(dato) {
    
    const id = dato._id
    const updates = {
        id: dato._id,
        nameTypeActivo: dato.nameTypeActivo,
        descrp: dato.descrp 
    }
    return clienteAxios.put(`/activoType/${id}`,updates);
}

export async function deleteActivoType(id) {
   
    return clienteAxios.delete(`/activoType/${id}`,id);

}